import ReactJsonView from '@microlink/react-json-view';
import { Modal } from 'antd';
import React from 'react';
import { IconVisible } from './BasicComponents/Icons';

export default function ReactJsonViewModal({ src }: { src: any }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleOk = () => {
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal open={isOpen} onOk={handleOk} onCancel={handleCancel}>
        <ReactJsonView src={src} />
      </Modal>
      <IconVisible onClick={() => setIsOpen(true)} style={{ cursor: 'pointer' }} />
    </>
  );
}
